import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/aDNKge",
    children: [
      {
        path: "/nGqi7w4e4p",
        name: "directorList",
        meta: {
          title: appInfo?.type == "smi" ? "Proprietors" : "Directors",
          authRequired: true,
          acc: ["y59821"],
        },
        component: () => import("../views/director/list.vue"),
      },
      {
        path: "/skC1ITtN/:tr?",
        name: "viewdirector",
        meta: {
          title: appInfo?.type == "smi" ? "View proprietor" : "View director",
          authRequired: true,
          acc: ["y59006"],
        },
        component: () => import("../views/director/view.vue"),
      },
      {
        path: "/aQ0Jt7Qg84/:tr?",
        name: "updatedirector",
        meta: {
          title:
            appInfo?.type == "smi" ? "Update proprietor" : "Update director",
          authRequired: true,
          acc: ["y43271"],
        },
        component: () => import("../views/director/update.vue"),
      },
      {
        path: "/qh4gVJj/:tr?",
        name: "updatedirectorPassword",
        meta: {
          title:
            appInfo?.type == "smi"
              ? "Update proprietor password"
              : "Update director password",
          authRequired: true,
          acc: ["y43271"],
        },
        component: () => import("../views/director/updatePassword.vue"),
      },
      {
        path: "/sMnTvnRO/:tr?",
          name: "Update.director.role",
        meta: {
        title:
          appInfo?.type == "smi"
            ? "Update proprietor role"
            : "Update director role",
          authRequired: true,
          acc: ["y43271"],
        },
        component: () => import("../views/director/updateRole.vue"),
      },
      {
        path: "/GFq562df",
        name: "newdirector",
        meta: {
          title: appInfo?.type == "smi" ? "New proprietor" : "New director",
          authRequired: true,
          acc: ["y92455"],
        },
        component: () => import("../views/director/new.vue"),
      },
    ],
  },
];
